import { AgentSurfaceId, AgentOverlayState } from "@/store/agent-overlay/types";
import { AgentActivitiesPage } from "@/pages/agent/agent-activities-page";
import { AgentOverviewPage } from "@/pages/agent/agent-overview-page";
import { AgentGoalsPage } from "@/pages/agent/agent-goals-page";
import { AgentGoalPage } from "@/pages/agent/agent-goal-page";
import { AgentInformationPage } from "@/pages/agent/agent-information-page";
import { AgentInformationItemPage } from "@/pages/agent/agent-information-item-page";
import { AgentProjectPage } from "@/pages/agent/agent-project-page";
import { AgentProjectTasksPage } from "@/pages/agent/agent-project-tasks-page";
import { AgentProjectsPage } from "@/pages/agent/agent-projects-page";
import { AgentTaskPage } from "@/pages/agent/agent-task-page";
import { AgentTasksPage } from "@/pages/agent/agent-tasks-page";
import { AgentRoutinesPage } from "@/pages/agent/agent-routines-page";
import { AgentSkillsPage } from "@/pages/agent/agent-skills-page";
import { AgentMemoryPage } from "@/pages/agent/memory/agent-memory-page";
import { AgentIntentModelProvider } from "@/pages/agent/components/agent-intent-model-context";
import { AGENT_INTENT_MODEL_V2_FEATURE_FLAG } from "@/pages/agent/components/agent-overlay-entry.constants";
import { useAppStore } from "@/store";

interface AgentOverlayContentProps {
  activeSurface: AgentOverlayState;
}

export const AgentOverlayContent = ({ activeSurface }: AgentOverlayContentProps) => {
  const { store } = useAppStore();
  const supportsGoals =
    store.spaceAccountFeatureFlags.getFlagStatus(AGENT_INTENT_MODEL_V2_FEATURE_FLAG) === true;

  return (
    <AgentIntentModelProvider hasIntentModel={supportsGoals}>
      <AgentOverlaySurface activeSurface={activeSurface} />
    </AgentIntentModelProvider>
  );
};

const AgentOverlaySurface = ({ activeSurface }: AgentOverlayContentProps) => {
  switch (activeSurface.surfaceId) {
    case AgentSurfaceId.Overview:
      return <AgentOverviewPage />;
    case AgentSurfaceId.Goals:
      return <AgentGoalsPage />;
    case AgentSurfaceId.Goal:
      return <AgentGoalPage goalId={activeSurface.goalId} />;
    case AgentSurfaceId.Projects:
      return <AgentProjectsPage />;
    case AgentSurfaceId.Project:
      return <AgentProjectPage projectId={activeSurface.projectId} />;
    case AgentSurfaceId.ProjectTasks:
      return <AgentProjectTasksPage projectId={activeSurface.projectId} />;
    case AgentSurfaceId.Tasks:
      return <AgentTasksPage />;
    case AgentSurfaceId.Task:
      return <AgentTaskPage taskId={activeSurface.taskId} />;
    case AgentSurfaceId.Information:
      return <AgentInformationPage />;
    case AgentSurfaceId.InformationItem:
      return <AgentInformationItemPage informationItemId={activeSurface.informationItemId} />;
    case AgentSurfaceId.Routines:
      return <AgentRoutinesPage />;
    case AgentSurfaceId.Memory:
      return <AgentMemoryPage />;
    case AgentSurfaceId.Skills:
      return <AgentSkillsPage />;
    case AgentSurfaceId.Activities:
      return <AgentActivitiesPage />;
    default:
      return <AgentOverviewPage />;
  }
};
